import { LOOP_STATUS } from "@/consts/loop";

export default class Status {
  constructor() {
    this.archiveItem = "archive";
  }
  archive(item) {
    return {
      ...item,
      status: LOOP_STATUS.FILED,
      teams: []
    };
  }
  activate(item) {
    return {
      ...item,
      status: LOOP_STATUS.ACTIVE,
      teams: []
    };
  }
  update(item, status) {
    if (status === this.archiveItem) {
      return this.archive(item);
    }
    return this.activate(item);
  }
}
